import useViewExtraAttacks from '../composables/useViewExtraAttacks'
import getCombatantNextRoundAction from './getCombatantNextRoundAction'
import getCombatantLastRoundAction from './getCombatantLastRoundAction'
import hasFutureSlots from './hasFutureSlots'
import store from '../store/index'
//-------------------
// get extra attacks
//-------------------
export default async function getExtraAttacks(parm) {
  // console.log("---------------------------");
  // console.log("getExtraAttacks...");
  return new Promise((resolve, reject) => {
    //--------------
    // access store
    //--------------
    const this_store = store.state.combat
    const caExtra = this_store.config.max_ca + 1
    let combatants = this_store.arena.arena_combatants
    //---------------------------------------------------------
    // get actives with no counters + has shield or 2nd weapon
    //---------------------------------------------------------
    let active_combatants = combatants.filter(
      (a) => a.status == 'Active' && a.counters == 0 && (a.shield || a.second_weapon),
    )
    let extra_attack_combatants = []
    // console.log("---------------------------------------------");
    // active_combatants.forEach((c) => {
    //   console.log("extra_attack_combatants name = " + c.name);
    // });
    // console.log("---------------------------------------------");

    // //--------------------
    // view extra attacks (checking for unused reactions for combs with 2nd wep/shield)
    //--------------------
    useViewExtraAttacks(parm)
      .then(async (extras) => {
        const eligibleCombatants = []

        for (let i = 0; i < active_combatants.length; i++) {
          const slots = await hasFutureSlots({
            id: active_combatants[i].id,
            this_round: parm.round,
            this_number: caExtra,
          })

          if (!slots.futureActions) {
            eligibleCombatants.push(active_combatants[i])
          }
        }

        console.log('getExtraAttacks: eligibleCombatants = ', eligibleCombatants)

        //-------------------------------
        // loop thru eligible combatants
        //-------------------------------
        for (let i = 0; i < eligibleCombatants.length; i++) {
          
          const combatant = eligibleCombatants[i]
          const lastAction = getCombatantLastRoundAction(combatant, this_store.config.max_ca)
          const nextAction = await getCombatantNextRoundAction(combatant, parm.round)
          const extraCombatant = extras.find((b) => b.combatant_id == combatant.id)
          const unusedReactionCount = extraCombatant
            ? extraCombatant.unused_reaction_count
            : (combatant.cr ?? 0)

          if (
            nextAction ||
            !lastAction.action?.eligible_extra_attack_last_action ||
            unusedReactionCount < 1
          ) {
            continue
          }

          // console.log("LOOP ACTIVES i = " + i);
          extra_attack_combatants.push(combatant)
        }
        console.log('getExtraAttacks: extra_attack_combatants = ', extra_attack_combatants)
        resolve(extra_attack_combatants)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
